{
  "title": "Clients",
  "description": "Personnes ayant pris rendez-vous avec votre entreprise.",
  "searchPlaceholder": "Rechercher des clients...",
  "columns": {
    "phone": "Téléphone",
    "verified": "Vérifié",
    "joined": "Inscrit le"
  },
  "show": {
    "notFound": "Client introuvable.",
    "back": "Retour aux clients",
    "unnamed": "Client sans nom",
    "verified": "Vérifié",
    "unverified": "Non vérifié",
    "phone": "Téléphone",
    "email": "E-mail",
    "joined": "Inscrit le",
    "appointmentsTitle": "Rendez-vous",
    "emptyAppointmentsTitle": "Aucun rendez-vous pour le moment",
    "emptyAppointmentsDescription": "Ce client n'a pas encore pris de rendez-vous avec votre entreprise."
  }
}
